<template>
  <div>
    <resource-dear-words
        style="margin-top: 50px;"
        :is-demo="true"
        :path-publishing="pathPublishing"
        :resource="selectedResource"
        :settings="settings"
        :user-data="userData"
        :is-management-mode="isManagementMode"
        :my-app-settings_is-display-activity="displayActivity"
        :my-app-settings_is-display-settings="displaySettings"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecordViews from "@/mixins/RecordViews";
import ResourceDearWords from "@/components/blockResources/resourceDearWords";
export default {
  name: "StandAlone_MyApp",
  mixins: [RecordViews],
  components: {
    ResourceDearWords
  },
  beforeMount() {
    this.myAppName = this.$route.params.myAppName;
    this.resourcePath = this.$route.params.resource;
    this.resourceItemPath = this.$route.params.resourceItem;

    if (this.resourcePath) {
      console.log(
          `Title: ${this.myAppName} | Resource: ${this.resourcePath} | ResourceItem: ${this.resourceItemPath} `
      );
    }
  },
  mounted() {
    this.getCornerData();
    if (this.user && this.$refs.corner) {
      this.$refs.corner.getCollectedCornerPublishings();
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      listPublishings: "listings/listPublishings"
    }),
    publishing() {
      return this.corner ? this.corner.doc : null;
    },
    pathPublishing(){
      return `/listings/publishings/items/${this.publishing ? this.publishing.id: ''}`
    }
  },
  methods: {
    handleNoCornerData() {
      this.$router.push("/");
    },
    getCornerData() {
      this.$store
          .dispatch("listings/getPublishingByMyAppName",
              {
                myAppName: this.myAppName
              }
          )
          .then(res => {
            if (Object.keys(res).length === 0) {
              this.handleNoCornerData();
            } else {
              this.corner = res;
              this.recordView(this.corner.id);

              //GET CREW
              if (res.doc.guides && res.doc.guides.length > 0) {
                res.doc.guides.forEach(guide => {});
              }
              //GET APPS
              if (res.doc.tools && res.doc.tools.length > 0) {
                res.doc.tools.forEach(tool => {
                  //this.getTool(tool.toolId);
                });
              }
            }
          })
          .catch(e => {
            console.log(e);
          });
    },
    recordView(publishingId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "publishings",
        entityId: publishingId,
        feedbackType: "views",
        sessionId: this.checkSession("sessions")
      });
    },
    handleToggleShelfPublishing(data) {
      if (!this.user) {
        this.$bvModal.show("loginModal");
      } else {
        if (!this.isFollowed) {
          this.$store
              .dispatch("user/followBlogger", this.publishing.blogger)
              .then(() => {
                this.getCollectedCornerPublishings();
                console.log("Followed");
              });
        } else {
          this.$store
              .dispatch("user/unfollowBlogger", this.publishing.blogger)
              .then(() => {
                this.getCollectedCornerPublishings();
                console.log("Unfollowed");
              });
        }
      }
    }
  },
  data() {
    return {
      corner: null,
      myAppName: null,
      resourcePath: null,
      resourceItemPath: null,
      collectedCorners: null,
      heartbeatId: null,
      heartBeatDisplay: null,
      selectedResource: null,
      settings: null,
      isManagementMode: null,
      userData: null,
      displayActivity: false,
      displaySettings: false
    };
  },
};
</script>
